import { LocaleEnum } from '@systemeio/ui'

export const getHelpPageLinkTwilio = (locale?: LocaleEnum) => {
  switch (locale) {
    case LocaleEnum.DEUTSCH:
      return 'https://help-de.systeme.io/article/4481-wie-sie-ihr-twilio-konto-in-systemeio-integrieren'
    case LocaleEnum.PORTUGUESE:
      return 'https://help-pt.systeme.io/article/4482-como-integrar-sua-conta-twilio-com-a-systeme-io'
    case LocaleEnum.CHINESE:
      return 'https://help-zh.systeme.io/article/4485-how-to-integrate-your-twilio-account-with-systeme-io'
    case LocaleEnum.ITALIAN:
      return 'https://help-it.systeme.io/article/4487-come-integrare-il-tuo-account-twilio-con-systeme-io'
    case LocaleEnum.HINDI:
      return 'https://help-hi.systeme.io/article/4488-how-to-integrate-your-twilio-account-with-systeme-io'
    case LocaleEnum.JAPANESE:
      return 'https://help-jp.systeme.io/article/4489-how-to-integrate-your-twilio-account-with-systeme-io'
    case LocaleEnum.ARABIC:
      return 'https://help-ar.systeme.io/article/4490-how-to-integrate-your-twilio-account-with-systeme-io'
    case LocaleEnum.FRENCH:
      return 'https://aide.systeme.io/article/4494-comment-integrer-votre-compte-twilio-a-systeme-io'
    case LocaleEnum.SPANISH:
      return 'https://help-es.systeme.io/article/4484-como-integrar-tu-cuenta-de-twilio-con-systeme-io'
    case LocaleEnum.DUTCH:
      return 'https://help-nl.systeme.io/article/4501-hoe-verbind-je-je-twilio-account-met-systeme-io'
    default: {
      return 'https://help.systeme.io/article/4477-how-to-integrate-your-twilio-account-with-systeme-io'
    }
  }
}
